export default "__VITE_ASSET__Gz5XL4oy__";